export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-700-normal.woff?fa82525960f77def4b5bdf478ad79ea2";